import * as React from 'react'

import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import Spinner from '~/client/src/shared/components/Spinner/Spinner'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import PresentationSetUpStore from '../PresentationSetUp.store'

interface IProps {
  store: PresentationSetUpStore
  isLoading: boolean
}

export default class PresentationModeHeader extends React.Component<IProps> {
  public render() {
    const { store, isLoading } = this.props

    return (
      <div className="mb30">
        <div className="text huge bold inline-block mr30 capitalize">
          {Localization.translator.presentationMode}
        </div>
        <div className="inline-block mr30">
          <Button
            variant="primary-outline"
            disabled={isLoading}
            onClick={store.showConfirmationPresentationDialog}
          >
            {isLoading ? <Spinner size="xs" /> : Localization.translator.turnOn}
          </Button>
        </div>
        <div className="text large light inline-block">
          {Localization.translator.presentationModeDescriptions.header}
        </div>
      </div>
    )
  }
}
